<section class="courses-area pt-50 pb-70">
  <div class="container">
    <div class="tab courses-list-tab">
      <ul class="tabs">
        <li><a href="#">Популярные курсы</a></li>
        <li><a href="#">Рекомендуемые курсы</a></li>
        <li><a href="#">Самые последние курсы</a></li>
      </ul>

      <div class="tab-content">
        <div class="tabs-item">
          <div class="row">
            <div *ngFor="let course of courses" class="col-lg-4 col-md-6">
              <div class="single-courses-item mb-30">
                <div class="courses-image">
                  <a class="d-block" routerLink="/course-details/{{course?._id}}">
                    <img alt="image" src="{{course.imgUrl || 'assets/img/courses/courses1.jpg'}}"></a>
                </div>

                <div class="courses-content">
                  <div class="d-flex justify-content-between align-items-center">
                    <div class="course-author d-flex align-items-center">
                      <img alt="image" class="shadow" src="{{course.instructor.imgUrl || 'assets/img/user1.jpg'}}">
                      <span>{{course.instructor.fullName}}</span>
                    </div>
                  </div>

                  <h3><a class="d-inline-block" routerLink="/course-details/{{course?._id}}">{{course.title}}</a></h3>
                  <p>{{course.brief}}</p>
                </div>

                <div class="courses-box-footer">
                  <ul>
                    <li class="students-number"><i class='bx bx-user'></i> {{course.enrolled}} студенты</li>
                    <li class="courses-lesson"><i class='bx bx-book-open'></i> {{course.chapters.length}} уроки</li>
                    <li class="courses-price">{{course.price}} c.</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="tabs-item">
          <div class="row">
            <div *ngFor="let course of recommendedCourses" class="col-lg-4 col-md-6">
              <div class="single-courses-item mb-30">
                <div class="courses-image">
                  <a class="d-block" routerLink="/course-details/{{course?._id}}">
                    <img alt="image" src="{{course.imgUrl}}"></a>
                </div>

                <div class="courses-content">
                  <div class="d-flex justify-content-between align-items-center">
                    <div class="course-author d-flex align-items-center">
                      <img alt="image" class="shadow" src="assets/img/user1.jpg">
                      <span>{{course.instructor.fullName}}</span>
                    </div>
                  </div>

                  <h3><a class="d-inline-block" routerLink="/course-details/{{course?._id}}">{{course.title}}</a></h3>
                  <p>{{course.brief}}</p>
                </div>

                <div class="courses-box-footer">
                  <ul>
                    <li class="students-number"><i class='bx bx-user'></i> {{course.enrolled}} студенты</li>
                    <li class="courses-lesson"><i class='bx bx-book-open'></i> {{course.chapters.length}} уроки</li>
                    <li class="courses-price">{{course.price}} c.</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="tabs-item">
          <div class="row">
            <div *ngFor="let course of latestCourses" class="col-lg-4 col-md-6">
              <div class="single-courses-item mb-30">
                <div class="courses-image">
                  <a class="d-block" routerLink="/course-details/{{course?._id}}">
                    <img alt="image" src="{{course.imgUrl}}"></a>
                </div>

                <div class="courses-content">
                  <div class="d-flex justify-content-between align-items-center">
                    <div class="course-author d-flex align-items-center">
                      <img alt="image" class="shadow" src="assets/img/user1.jpg">
                      <span>{{course.instructor.fullName}}</span>
                    </div>
                  </div>

                  <h3><a class="d-inline-block" routerLink="/course-details/{{course?._id}}">{{course.title}}</a></h3>
                  <p>{{course.brief}}</p>
                </div>

                <div class="courses-box-footer">
                  <ul>
                    <li class="students-number"><i class='bx bx-user'></i> {{course.enrolled}} студенты</li>
                    <li class="courses-lesson"><i class='bx bx-book-open'></i> {{course.chapters.length}} уроки</li>
                    <li class="courses-price">{{course.price}} c.</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
